import React, { useState } from "react";
import PropTypes from "kf-proptypes/widgets";

import { isEmpty } from "base/utils";

import { SearchWidget } from "./search.widget.jsx";
import { DropDownWrapper, NoResultsFound } from "./index.jsx";
import { UserMenuItem } from "@widgets/datadisplay/usermenuitem/index.jsx";

import styles from "./singleuserselect.css";

import ActiveIcon from "../active_right.svg";

export function SingleUserSelectWidget(props) {
  let {
    onSearch,
    searchAutoFocus = false,
    onChange = null,
    dataSource = [],
    value
  } = props;
  let [searchText, setSearchText] = useState("");

  return (
    <div>
      {onSearch && (
        <SearchWidget
          onSearch={(value) => {
            setSearchText(value);
            onSearch(value);
          }}
          searchAutoFocus={searchAutoFocus}
        />
      )}
      <DropDownWrapper>
        <>
          {dataSource &&
            dataSource.map((item, index) => {
              if (!item) {
                return null;
              }
              return (
                <SingleUserListItem
                  user={item ? item : "NA"}
                  key={index}
                  active={JSON.stringify(value) === JSON.stringify(item)}
                  onClick={onChange}
                />
              );
            })}
          {isEmpty(dataSource) && <NoResultsFound searchText={searchText} />}
        </>
      </DropDownWrapper>
    </div>
  );
}

SingleUserSelectWidget.propTypes = {
  onSearch: PropTypes.string,
  onChange: PropTypes.func,
  dataSource: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.shape({
      _id: PropTypes.string,
      Kind: PropTypes.string,
      Email: PropTypes.string,
      Name: PropTypes.string,
      key: PropTypes.string,
      label: PropTypes.string
    })
  ]),
  value: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.shape({
      _id: PropTypes.string,
      Kind: PropTypes.string,
      Email: PropTypes.string,
      Name: PropTypes.string,
      key: PropTypes.string,
      label: PropTypes.string
    })
  ]),
  searchAutoFocus: PropTypes.bool
};

export function SingleUserListItem(props) {
  let { user, onClick, active = false, className = "" } = props;
  let { disabled = false } = user;
  return (
    <div
      onClick={() => {
        if (onClick) {
          if (!disabled) {
            onClick(user);
          }
        }
      }}
      className={`${disabled && styles.disabled} ${
        styles.dropDownItem
      } ${className}`}
    >
      <UserMenuItem
        userId={user._id}
        name={user.Name}
        email={user.Email}
        kind={user.Kind}
      />
      {active && <ActiveIcon />}
    </div>
  );
}

SingleUserListItem.propTypes = {
  user: PropTypes.shape({
    disabled: PropTypes.bool,
    Kind: PropTypes.string.isRequired,
    Name: PropTypes.string.isRequired,
    _id: PropTypes.string.isRequired,
    Email: PropTypes.string.isRequired
  }),
  labelRenderer: PropTypes.func,
  onClick: PropTypes.func,
  active: PropTypes.bool,
  className: PropTypes.string
};
